import angular from 'angular';
import textAngular from 'textangular';
import textangularConfig from './textangular.decorator';
import CommentSectionComponent from './subcase-comment-section.component';
import 'textangular/dist/textAngular.css';

export default angular
  .module('verifyApp.subcaseCommentSection', [textAngular])
  .config(textangularConfig)
  .component('subcaseCommentSection', CommentSectionComponent)
  .name;



// WEBPACK FOOTER //
// ./client/components/subcase-comment-section/index.js